import React from "react";
import { Chat } from "../../../types/conversations";
import utils from "../../../helpers/utils";

interface AvatarProps {
  chat: Chat;
}

export const Avatar: React.FC<AvatarProps> = ({ chat }) => {
  const imageSrc =
    (chat.avatar
      ? utils.getUriImage(chat.avatar, chat.userId ? String(chat.userId) : "")
      : null) ||
    `https://ui-avatars.com/api/?name=${encodeURIComponent(chat.name)}&background=85368c&color=fff&size=200`;

  const fallbackSrc = `https://ui-avatars.com/api/?name=${encodeURIComponent(chat.name)}&background=85368c&color=fff&size=200`;

  return (
    <div className="relative flex-shrink-0">
      <div className="w-12 h-12 rounded-full overflow-hidden bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center ring-2 ring-purple-100 dark:ring-purple-900/30 transition-transform hover:scale-105 md:w-11 md:h-11">
        <img
          src={imageSrc}
          alt={chat.name}
          className="h-full w-full object-cover"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.src = fallbackSrc;
          }}
        />
      </div>
      {chat.online && (
        <div className="absolute -bottom-0.5 -right-0.5 w-3.5 h-3.5 bg-green-500 rounded-full border-[3px] border-white dark:border-gray-800 shadow-sm animate-pulse" />
      )}
    </div>
  );
};
